import React from 'react';

import { cn } from '@lyearn/style';
import { SideBarMode, SidebarSection } from '@/modules/corporate/modules/admin/hooks/useSidebar';

import SidebarItem from './SidebarItem';
import {
  SIDEBAR_LABEL_HIDDEN,
  SIDEBAR_LABEL_TRANSITION,
  SIDEBAR_TEXT,
  SIDEBAR_TEXT_COLOR,
} from './theme';

const Section = ({
  section,
  mode,
  collapsed = false,
  className,
}: {
  section: SidebarSection;
  mode?: SideBarMode;
  collapsed?: boolean;
  className?: string;
}) => {
  return (
    <div className={cn('flex w-full flex-col', section?.className, className)}>
      {section.title ? (
        <p
          className={cn(
            'mb-6 ml-6 h-20 truncate',
            SIDEBAR_TEXT_COLOR,
            SIDEBAR_TEXT,
            SIDEBAR_LABEL_TRANSITION,
            collapsed && SIDEBAR_LABEL_HIDDEN,
          )}>
          {section.title}
        </p>
      ) : null}
      {!!section.node && <div>{section.node}</div>}
      <div className="flex w-full flex-col gap-4">
        {section.children.map((sidebarItem) => (
          <SidebarItem
            key={sidebarItem.id}
            collapsed={collapsed}
            mode={mode}
            sidebarItem={sidebarItem}
          />
        ))}
      </div>
    </div>
  );
};

export default Section;
